/**
 * Decodes basic HTML entities like &lt; and &gt; into their character equivalents.
 * Used primarily for titles where text might be escaped in the database but 
 * needs to be rendered as plain text in React.
 */
export const decodeHTMLEntities = (text: string | any): string => {
    if (typeof text !== 'string') return text || '';
    return text
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>');
};
